// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2xpmi","buttons":"SendReceipts_buttons__1FFl8","email":"SendReceipts_email__DrcJ1","bookApptTitle":"SendReceipts_bookApptTitle__D9Eob"};